/* @flow */
import * as React from 'react';
import ChatWelcomeMessage from 'chat/components/ChatWelcomeMessage';
import StreamScrollableArea from './StreamScrollableArea';

export class StreamPlaceholder extends React.Component<*, *> {
  render() {
    return (
      <StreamScrollableArea>
        <ChatWelcomeMessage
          firstHeader={<div>This is the beginning of your message history.</div>}
          secondHeader={null}
        />
      </StreamScrollableArea>
    );
  }
}

export default StreamPlaceholder;
